import { useClientSaveSigningQuestionnaire } from 'api/requests';
import { ClientDocumentGroupName } from 'api/types/data';
import { ClientEntity } from 'api/types/entity';

import { useClientSigningDocumentGroup } from './useClientSigningDocumentGroup';

export const useClientSigningQuestionnaire = (client: ClientEntity) => {
  const {
    signingQuestionnaire,
    loading: submitLoading,
    error: submitError,
  } = useClientSaveSigningQuestionnaire();

  const { documents, formError, loading, onClickDocument, onSubmit } =
    useClientSigningDocumentGroup(
      client,
      ClientDocumentGroupName.Questionnaire,
      signingQuestionnaire,
      submitError
    );

  return {
    documents,
    loading,
    submitLoading,
    formError,
    onClickDocument,
    onSubmit,
  };
};
